import React from "react";
import styled, { keyframes } from "styled-components";
import { Box } from "../Box";

interface Props {
  show?: boolean;
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const FadeBoxWrapper = styled(Box)`
  display: ${props => (props.show ? "block" : "none")};
  animation: ${props => (props.show ? fadeIn : null)} 0.7s linear;
`;

export const FadeBox: React.FC<Props> = ({ show, children }) => (
  <FadeBoxWrapper show={show} data-testid="FadeBox">
    {children}
  </FadeBoxWrapper>
);
